/**
 * Guarded `String()` for values that arrived from a `catch` binding.
 *
 * Internal to this package on purpose: `coerceError` and `summarizeErrorCause` are the two
 * supported entry points, and both must produce the same fallback text for the same input.
 * Neither this function nor the constant is re-exported from `index.ts`; the constant is exported
 * from the module so this package's tests can assert against it instead of a copied literal.
 */
export const UNSTRINGIFIABLE_VALUE = "Unstringifiable thrown value";

/**
 * `String(value)` throws when the value is a null-prototype object or an object with a throwing
 * `toString`/`Symbol.toPrimitive`. Both callers run on failure paths (error-boundary renders,
 * error constructors), so stringification must never be the thing that throws.
 */
export function stringifyUnknown(value: unknown): string {
  try {
    return String(value);
    // eslint-disable-next-line no-catch-all/no-catch-all -- callers run on error-boundary render paths and inside error constructors, where a throw from the stringifier would replace the failure being reported
  } catch {
    return UNSTRINGIFIABLE_VALUE;
  }
}
